function loadMoreProducts(){
var products_on_page = jQuery('.products-on-page');
var next_url = products_on_page.data('next-url');
var delay_type = products_on_page.data('delay-type');
var delay_speed = products_on_page.data('delay-speed');
var load_more_btn = jQuery('.load-more__btn');
var load_more_spinner = jQuery('.load-more__spinner');
var current_page = products_on_page.data('current-page');
var last_item = products_on_page.find(".grid__item").last().data("product-id");
jQuery.ajax(
    {
        url: next_url,
        type: 'GET',
        dataType: 'html',
        beforeSend: function(){
            //remove appended class from products who are now not the most recently appended
            products_on_page.find('.appended_product').each(function() {
                $(this).removeClass('appended_product');
            })
            load_more_btn.hide();
            load_more_spinner.show();
            last_item = products_on_page.find(".grid__item").last().data("product-id");
        }
    }
).done(function(next_page){
    //find the collection grid, update the new paginate url, update response product count
    var new_products = jQuery(next_page).find('.products-on-page');
    var new_url = new_products.data('next-url');
    var loaded = 0;
    var new_products_html = $(new_products.html());
    var final_products = [];
    var final_product_count = 0;
    //testing each node in response to make sure it is a valid node, and if so add to the final product array to append
    new_products_html.each(function() {
        //if node type isn't text, we can add the node
        if ($(this)[0].nodeType == 1) {
            $(this).find("img").first().attr("loading", "eager");
            final_products.push($(this)[0]);
            final_product_count++;
            $(this).addClass("appended_product");
            //adding duplicate_product class to items appended on collections with ads that are backfilling products to make sure
            //products don't display multiple times in a row.
            let productClass = "#product-grid .grid__item[data-product-id='" + $(this).data("product-id") + "']";
            let productElement = $(productClass);
            if (productElement.length > 0) {
              $(this).addClass("duplicate_product");
            }
            if ($(this).data("product-id") == last_item) {
                $(this).addClass("duplicate_product");
            }
        }
    });
    $(final_products).each(function() {
        $(this).find("img").first().bind("load", function() {
            loaded++;
            //if loaded equals the number of products in ajax call, all first images have been loaded.
            if (loaded == final_product_count) {
                window.postMessage({ type: 'collection_grid', action: "products_loaded", load_more: true }, '*');
                load_more_spinner.hide();
                products_on_page.append(final_products);
                if (delay_type == 'fade') {
                    $(final_products).hide().fadeIn(delay_speed);
                }
                if (new_url) {
                    load_more_btn.show();
                    next_url = new_url;
                    products_on_page.data('next-url', next_url);
                    current_page++;
                    products_on_page.data('current-page', current_page);
                }
            }
        });
    });
});
} 
